export class File {
  constructor(
        readonly name: string,
        readonly url: string,
        readonly size?: number
  ) {}
}